import { SearchFacetOptions } from './search-facet-options.model';
import { SearchFacetFilter } from './search-facet-filter.model';
import { SearchFacetRangeFilter } from './search-facet-range-filter.model';
import { SearchMatchFilter } from './search-match-filter.model';
import { SearchRangeFilter } from './search-range-filter.model';

export class SearchOptions {
  public q: string;
  public source: string;
  public start: number;
  public rows: number;
  public facetOptions: SearchFacetOptions;
  public facetFilters: SearchFacetFilter[] = [];
  public facetRangeFilters: SearchFacetRangeFilter[] = [];
  public otherFilters: SearchMatchFilter[] = [];

  public getMatchFilters(): SearchMatchFilter[] {
    const matchFilters: SearchMatchFilter[] = [];
    for (const facetFilter of this.facetFilters) {
      const matchFilter = new SearchMatchFilter();
      if (facetFilter.excludedFacet) {
        matchFilter.field =
          '{!tag=' + facetFilter.token + '}' + facetFilter.field;
      } else {
        matchFilter.field = facetFilter.field;
      }
      if (facetFilter.isString === true) {
        matchFilter.value = '"' + this.urlDecode(facetFilter.value) + '"';
      } else {
        matchFilter.value = this.urlDecode(facetFilter.value);
      }
      matchFilters.push(matchFilter);
    }
    for (const otherFilter of this.otherFilters) {
      matchFilters.push(otherFilter);
    }
    return matchFilters;
  }

  public getRangeFilters(): SearchRangeFilter[] {
    const matchFilters: SearchRangeFilter[] = [];
    for (const facetFilter of this.facetRangeFilters) {
      const rangeFilter = new SearchRangeFilter();
      if (facetFilter.excludedFacet) {
        rangeFilter.field =
          '{!tag=' + facetFilter.token + '}' + facetFilter.field;
      } else {
        rangeFilter.field = facetFilter.field;
      }
      rangeFilter.query = facetFilter.query;
      rangeFilter.start = this.urlDecode(facetFilter.fromValue);
      rangeFilter.end = this.urlDecode(facetFilter.toValue);
      matchFilters.push(rangeFilter);
    }
    return matchFilters;
  }

  private urlDecode(text: string): string {
    const decodedText = decodeURIComponent(text);
    return decodedText;
  }
}
